import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';

import PaymentPage from '@/features/payments/PaymentPage';

const HandleMagicLink = lazy(
  () => import('@/features/auth/components/HandleMagicLink'),
);
const Home = lazy(() => import('@/features/home/Home'));
const AuthenticatedAppLayout = lazy(() => import('./AuthenticatedAppLayout'));
const UnauthenticatedAppLayout = lazy(
  () => import('./UnauthenticatedAppLayout'),
);
const Dashboard = lazy(() => import('@/features/dashboard/Dashboard'));
const HandleEmailVerified = lazy(
  () => import('@/features/auth/components/HandleEmailVerified'),
);
const MagicLinkLoginForm = lazy(
  () => import('@/features/auth/components/MagicLinkLoginForm'),
);
const EmailPasswordLoginForm = lazy(
  () => import('@/features/auth/components/EmailPasswordLoginForm'),
);
const ForgotPasswordForm = lazy(
  () => import('@/features/auth/components/ForgotPasswordForm'),
);
const RegisterForm = lazy(
  () => import('@/features/auth/components/RegisterForm'),
);

const AppRoutes = () => {
  const userState = useCurrentUser();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path='/' element={<Home />} />
        {/* Deprecated, use /pay instead */}
        <Route path='/paymentpage' element={<PaymentPage />} />
        <Route path='/pay' element={<PaymentPage />} />
        <Route path='/:firmHandle'>
          <Route path='after-magic-link' element={<HandleMagicLink />} />

          {userState.type === 'authenticated' ? (
            <Route
              element={<AuthenticatedAppLayout authUser={userState.user} />}
            >
              <Route
                path='email-verified'
                element={<HandleEmailVerified currentUser={userState.user} />}
              />
              <Route
                path='dashboard'
                element={<Dashboard currentUser={userState.user} />}
              />
              <Route
                path='*'
                element={<Navigate to='../dashboard' replace={true} />}
              />
            </Route>
          ) : userState.type === 'unauthenticated' ? (
            <Route element={<UnauthenticatedAppLayout />}>
              <Route
                path='email-verified'
                element={<HandleEmailVerified currentUser={undefined} />}
              />

              <Route index element={<Navigate to='login' replace />} />
              <Route path='login' element={<MagicLinkLoginForm />} />
              <Route
                path='login/password'
                element={<EmailPasswordLoginForm />}
              />
              <Route path='forgot-password' element={<ForgotPasswordForm />} />
              <Route path='register' element={<RegisterForm />} />

              <Route path='*' element={<Navigate to='../login' replace />} />
            </Route>
          ) : null}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
